import styled from 'styled-components'
import { grid, GridProps } from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { LANDING_CONTENT_WIDTH_PX } from 'Constants/Landing'

const shouldForwardProp = (prop: string) =>
  !DIV_SHOULD_FORWARD_PROP.includes(prop)

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<GridProps>`
  display: grid;
  width: 100%;
  max-width: ${LANDING_CONTENT_WIDTH_PX}px;
  gap: ${themeGet('space.9')}px;

  ${grid}
`

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${themeGet('space.6')}px;
  background-color: ${themeGet('colors.background.screen')};
  border-radius: 20px;
  padding: ${themeGet('space.8')}px;
  color: ${themeGet('colors.primary.main')};
  box-shadow: ${themeGet('shadows.block')};

  svg {
    flex-shrink: 0;
  }
`
